// hello Joe
import Vue from 'vue'
import Vuex from 'vuex'

import * as dl from '../dataLoading'
import * as md from '../mapDrawing'
import * as d3 from "d3";
import { reverse } from 'd3';

// =====
// =====
// TYPES
// =====
// =====


interface ModelCounts_t {
  fipsCode: string;
  vaccinationGoalCode: string;
  vaccinationRateCode: string;
  caseCount: number;
  deathCount: number;
}

interface States {
  fipsCode: string;
  abbrev: string;
  stateName: string;
  jurisdiction: string;
}

interface UiFipsT {
  readonly fipsCode: string;
  readonly name: string;
  readonly population: number;
  readonly abbrev: string;
  readonly parent: string;
  readonly fullName: string;
  readonly noVaxCaseCount: number;
  readonly noVaxDeathCount: number;
}

interface PersonnelDisplay {
  jurisdiction: string;
  population: number;
  clinics: number;
  workers: number;
}

interface TableRow {
  name: string;
  noVaxCases: number;
  withVaxCases: number;
  casesAverted: number;
  noVaxDeaths: number;
  withVaxDeaths: number;
  deathsAverted: number;
}

interface VaxGoal {
  goal: string;
  cases: number;
  casesAverted: number;
  deaths: number;
  deathsAverted: number;
}

interface StoreState_t {
  currentRoute: string;
  showObjective: number;
  emailHref: string;
  shareURL: string;
  queryURL: string;
  selectedState: string;
  selectedStateAbbrev: string;
  selectedStateName: string;
  selectedStateCounties: Array<UiFipsT>;
  stateNavRoute: string;
  selectedCounty: string;
  selectedCountyName: string;
  selectedCountyURL: string;
  vaccinationGoal: string;
  targetPercent: number;
  vaccinationRateSliderNum: number;
  vaccinationRateSlider: string;
  vaccinationRateLabel: string;
  selectedMap: string;
  selectedMapClass: string;
  timestamp: string;
  displayOutput: string;
  copyDisplay: string;
  isDataLoaded: boolean;
  fipsDataRaw: Map<string,dl.fips_t>;
  fipsNation: UiFipsT;
  fipsStateArray: Array<UiFipsT>;
  fipsCountyArray: Array<UiFipsT>;
  personnelNation: Array<PersonnelDisplay>;
  personnelCounties: Array<PersonnelDisplay>;
  personnelOption: string;
  shiftHours: number;
  vaxPerHour: number;
  shiftsPerDay: number;
  campaignDuration: number;
  totalVaxPerDay: number;
  nationDataArray: Array<TableRow>;
  nationCasesAverted: number;
  nationDeathsAverted: number;
  nationPageNo: number;
  stateDataArray: Array<VaxGoal>;
  countyDataArray: Array<VaxGoal>;
  stateCasesAverted: number;
  stateDeathsAverted: number;
  countyCasesAverted: number;
  countyDeathsAverted: number;
}



// =========
// =========
// FUNCTIONS
// =========
// =========

function setPersonnelDisplay(state: StoreState_t) {
  const vaxPerClinicPerDay = state.shiftHours * state.vaxPerHour * state.shiftsPerDay * 10;
  state.totalVaxPerDay = vaxPerClinicPerDay;
  // const vaxPerClinicPerDay = 240000;
  const newArr = [];
  // if (state.selectedState !== '00') {
    
    for (let i = 0; i < state.fipsCountyArray.length; i++) {
      const roundedPop = Math.ceil(state.fipsCountyArray[i].population / 100) * 100;
      let clinics = (roundedPop * state.targetPercent) / (vaxPerClinicPerDay * state.campaignDuration);
      clinics = Math.ceil(clinics);
      const workers = clinics * 170 * state.shiftsPerDay;
      const tempObj = {
        isActive: true,
        jurisdiction: state.fipsCountyArray[i].fullName,
        population: roundedPop,
        clinics: clinics,
        workers: workers
      }
      newArr.push(tempObj);
    }
    state.personnelCounties = newArr;
  // }
  const nationArr = [];
    for (let i = 0; i <= state.fipsStateArray.length; i++) {
      
      if (state.fipsStateArray[i] != undefined)
      
      {
        const roundedPop = Math.ceil(state.fipsStateArray[i].population / 100) * 100;
        let clinics = (roundedPop * state.targetPercent) / (vaxPerClinicPerDay * state.campaignDuration);
      clinics = Math.ceil(clinics);
      const workers = clinics * 170 * state.shiftsPerDay;
      const tempObj = {
        isActive: true,
        jurisdiction: state.fipsStateArray[i].name,
        population: roundedPop,
        clinics: clinics,
        workers: workers
      }
      nationArr.push(tempObj);}
    }
    state.personnelNation = nationArr;
}

function updatePersonnelDisplay(state: StoreState_t) {
  const vaxPerClinicPerDay = state.shiftHours * state.vaxPerHour * state.shiftsPerDay * 10;
  state.totalVaxPerDay = vaxPerClinicPerDay;
  const newArr = [];
    
    for (let i = 0; i < state.personnelCounties.length; i++) {
      const roundedPop = Math.ceil(state.personnelCounties[i].population / 100) * 100;
      let clinics = (roundedPop * state.targetPercent) / (vaxPerClinicPerDay * state.campaignDuration);
      clinics = Math.ceil(clinics);
      const workers = clinics * 170 * state.shiftsPerDay;
      const tempObj = {
        isActive: true,
        jurisdiction: state.personnelCounties[i].jurisdiction,
        population: roundedPop,
        clinics: clinics,
        workers: workers
      }
      newArr.push(tempObj);
    }
    state.personnelCounties = newArr;
  const nationArr = [];
    for (let i = 0; i <= state.personnelNation.length; i++) {
      
      if (state.personnelNation[i] != undefined)
      
      {
        const roundedPop = Math.ceil(state.personnelNation[i].population / 100) * 100;
        let clinics = (roundedPop * state.targetPercent) / (vaxPerClinicPerDay * state.campaignDuration);
      clinics = Math.ceil(clinics);
      const workers = clinics * 170 * state.shiftsPerDay;
      const tempObj = {
        isActive: true,
        jurisdiction: state.personnelNation[i].jurisdiction,
        population: roundedPop,
        clinics: clinics,
        workers: workers
      }
      nationArr.push(tempObj);}
    }
    state.personnelNation = nationArr;
}

async function getDataSet(i_FipsCode: string, i_VaxGoalCode: string, i_VaxRateCode: string) {
  let runConfigCode = "2-DosePfizer/Moderna,1DoseJ&J(" + i_VaxGoalCode;
  if (i_VaxRateCode !== "baseRate") {
    runConfigCode = runConfigCode + "," + i_VaxRateCode;
  }
  runConfigCode = runConfigCode + ")";

  // console.log("getDataSet :: runConfigCode: " + runConfigCode)
  const ds = await dl.getModelDataPromise(runConfigCode);
 
  return ds;
}


async function getSelectedDataSet(i_State: StoreState_t, i_FipsCode: string) {
  // for supplied fips code, look at state and return data set

  return getDataSet(i_FipsCode, i_State.vaccinationGoal, i_State.vaccinationRateSlider)
}


async function getMaxModelCounts(i_FipsCode: string, i_VaxGoalCode: string, i_VaxRateCode: string) {
  const ds = await getDataSet(i_FipsCode, i_VaxGoalCode, i_VaxRateCode);
  const vd = dl.getLastValidDate();
  const md: dl.modelData_t = ds.get(i_FipsCode + ":" + vd);

  const o: ModelCounts_t = {
    fipsCode: md.fipsCode,
    vaccinationGoalCode: i_VaxGoalCode,
    vaccinationRateCode: i_VaxRateCode,
    caseCount: md.projectedCasesBest,
    deathCount: md.projectedDeathsBest
  };
  return o;
}

function setNationTable(state: StoreState_t) {
  const dataArr = new Array<TableRow>();
  getMaxModelCounts(state.fipsNation.fipsCode, state.vaccinationGoal, state.vaccinationRateSlider).then(obj => {
    const dataObj = {
      name: "United States",
      withVaxCases: obj.caseCount,
      noVaxCases: state.fipsNation.noVaxCaseCount,
      casesAverted: state.fipsNation.noVaxCaseCount - obj.caseCount,
      withVaxDeaths: obj.deathCount,
      noVaxDeaths: state.fipsNation.noVaxDeathCount,
      deathsAverted: state.fipsNation.noVaxDeathCount - obj.deathCount
    };
    state.nationDeathsAverted = dataObj.deathsAverted;
    state.nationCasesAverted = dataObj.casesAverted;
    dataArr.push(dataObj);
  for (let i = 0; i < state.fipsStateArray.length; i++) {
    
    getMaxModelCounts(state.fipsStateArray[i].fipsCode, state.vaccinationGoal, state.vaccinationRateSlider).then(obj => {
    const dataObj = {
      name: state.fipsStateArray[i].name,
      withVaxCases: obj.caseCount,
      noVaxCases: state.fipsStateArray[i].noVaxCaseCount,
      casesAverted: state.fipsStateArray[i].noVaxCaseCount - obj.caseCount,
      withVaxDeaths: obj.deathCount,
      noVaxDeaths: state.fipsStateArray[i].noVaxDeathCount,
      deathsAverted: state.fipsStateArray[i].noVaxDeathCount - obj.deathCount
    };
    dataArr.push(dataObj);
    });
    state.nationDataArray = dataArr;
  }
})
}

function setStateCountyArray(state: StoreState_t, target: string) {
  let fips = '';
  let noVaxCases = 0;
  let noVaxDeaths = 0;
  if (target === 'state') {
    fips = state.selectedState;
    noVaxCases = state.fipsStateArray.filter(o => o.fipsCode === fips)[0].noVaxCaseCount;
    noVaxDeaths = state.fipsStateArray.filter(o => o.fipsCode === fips)[0].noVaxDeathCount;
  } else {
    fips = state.selectedCounty;
    noVaxCases = state.fipsCountyArray.filter(o => o.fipsCode === fips)[0].noVaxCaseCount;
    noVaxDeaths = state.fipsCountyArray.filter(o => o.fipsCode === fips)[0].noVaxDeathCount;
  }

  const arr = [{
    goal: "No Vaccination",
    cases: noVaxCases,
    casesAverted: 0,
    deaths: noVaxDeaths,
    deathsAverted: 0
  }];

  getMaxModelCounts(fips, state.vaccinationGoal, "-30%").then(obj => {
    const item = {
      goal: "-30%",
      deaths: obj.deathCount,
      deathsAverted: noVaxDeaths - obj.deathCount,
      cases: obj.caseCount,
      casesAverted: noVaxCases - obj.caseCount
    };
    arr.push(item);
    getMaxModelCounts(fips, state.vaccinationGoal, "-20%").then(obj => {
      const item = {
        goal: "-20%",
        deaths: obj.deathCount,
        deathsAverted: noVaxDeaths - obj.deathCount,
        cases: obj.caseCount,
        casesAverted: noVaxCases - obj.caseCount
      };
      arr.push(item);
      getMaxModelCounts(fips, state.vaccinationGoal, "-10%").then(obj => {
        const item = {
          goal: "-10%",
          deaths: obj.deathCount,
          deathsAverted: noVaxDeaths - obj.deathCount,
          cases: obj.caseCount,
          casesAverted: noVaxCases - obj.caseCount
        };
        arr.push(item);
        getMaxModelCounts(fips, state.vaccinationGoal, "baseRate").then(obj => {
          const item = {
            goal: "Base Vaccination",
            deaths: obj.deathCount,
            deathsAverted: noVaxDeaths - obj.deathCount,
            cases: obj.caseCount,
            casesAverted: noVaxCases - obj.caseCount
          };
          arr.push(item);
          getMaxModelCounts(fips, state.vaccinationGoal, "+10%").then(obj => {
            const item = {
              goal: "+10%",
              deaths: obj.deathCount,
              deathsAverted: noVaxDeaths - obj.deathCount,
              cases: obj.caseCount,
              casesAverted: noVaxCases - obj.caseCount
            };
            arr.push(item);
            getMaxModelCounts(fips, state.vaccinationGoal, "+20%").then(obj => {
              const item = {
                goal: "+20%",
                deaths: obj.deathCount,
                deathsAverted: noVaxDeaths - obj.deathCount,
                cases: obj.caseCount,
                casesAverted: noVaxCases - obj.caseCount
              };
              arr.push(item);
              getMaxModelCounts(fips, state.vaccinationGoal, "+30%").then(obj => {
                const item = {
                  goal: "+30%",
                  deaths: obj.deathCount,
                  deathsAverted: noVaxDeaths - obj.deathCount,
                  cases: obj.caseCount,
                  casesAverted: noVaxCases - obj.caseCount
                };
                arr.push(item);

                if (target === 'state') {
                  state.stateDataArray = arr;
                } else {
                  state.countyDataArray = arr;
                }
              });
            });
          });
        });
      });

    });
  });
}


function averted(state: StoreState_t, target: string) {
  let fips = '';
  let noVaxCases = 0;
  let noVaxDeaths = 0;
  
  if (target==='state') {
    fips = state.selectedState;
    const jurisdiction = state.fipsStateArray.filter(o => o.fipsCode === fips)[0];
    noVaxCases = jurisdiction.noVaxCaseCount;
    noVaxDeaths = jurisdiction.noVaxDeathCount;
  }
  else {
    fips = state.selectedCounty;
    const jurisdiction = state.fipsCountyArray.filter(o => o.fipsCode === fips)[0];
    noVaxCases = jurisdiction.noVaxCaseCount;
    noVaxDeaths = jurisdiction.noVaxDeathCount;
  }
  getMaxModelCounts(fips, state.vaccinationGoal, state.vaccinationRateSlider).then(obj => {
    const caseDiff = noVaxCases - obj.caseCount;
    const deathDiff = noVaxDeaths - obj.deathCount;
    if (target === 'state') {
      state.stateCasesAverted = caseDiff;
      state.stateDeathsAverted = deathDiff;
    }
    else {
      state.countyCasesAverted = caseDiff;
      state.countyDeathsAverted = deathDiff;
    }
  });
}

function drawNation() {
  const canvas: md.canvas_t = {
    containerId: null,
    svgWidth: null,
    svgHeight: null,
    projection: null,
    fipsCode: null
  };

  canvas.containerId = "nationSvg";
  canvas.svgWidth = parseInt(d3.select('#nationMapContainer').style('width'));
  canvas.svgHeight = canvas.svgWidth * 0.667;
  canvas.projection = md.geoAlbersUsaTerritories();
  canvas.fipsCode = "00";

  md.draw(canvas);
}

function drawPersonnel() {
  const canvas: md.canvas_t = {
    containerId: null,
    svgWidth: null,
    svgHeight: null,
    projection: null,
    fipsCode: null
  };

  canvas.containerId = "personnelSvg";
  canvas.svgWidth = parseInt(d3.select('#nationMapContainer').style('width'));
  canvas.svgHeight = canvas.svgWidth * 0.667;
  canvas.projection = md.geoAlbersUsaTerritories();
  canvas.fipsCode = "00";

  md.draw(canvas);
}


function drawState(i_State: StoreState_t) {
  const canvas: md.canvas_t = {
    containerId: null,
    svgWidth: null,
    svgHeight: null,
    projection: null,
    fipsCode: null
  };

  canvas.containerId = "stateSvg";
  canvas.svgWidth = parseInt(d3.select('#stateMapContainer').style('width'));
  canvas.svgHeight = canvas.svgWidth * 0.667;
  canvas.fipsCode = i_State.selectedState;
  if (canvas.fipsCode === '02')  canvas.projection = md.geoAlbersUsaTerritories();
  else canvas.projection = d3.geoMercator();


  md.draw(canvas);
}

function resetPersonnelCustom(i_State: StoreState_t) {
 const natArr = i_State.personnelNation.filter(item => item.jurisdiction != 'Custom');
 const countyArr = i_State.personnelCounties.filter(item => item.jurisdiction != 'Custom');
 i_State.personnelNation = natArr;
i_State.personnelCounties = countyArr;
}

function drawCounty(i_State: StoreState_t) {
  const canvas: md.canvas_t = {
    containerId: null,
    svgWidth: null,
    svgHeight: null,
    projection: null,
    fipsCode: null
  };

  canvas.containerId = "countySvg";
  canvas.svgWidth = parseInt(d3.select('#countyMapContainer').style('width'));
  canvas.svgHeight = canvas.svgWidth * 0.667;
  canvas.fipsCode = i_State.selectedCounty === "" ? "01001" : i_State.selectedCounty;


  if (canvas.fipsCode.substring(0,2) === '02') canvas.projection = md.geoAlbersUsaTerritories();
  else canvas.projection = d3.geoMercator();


  md.draw(canvas);
}

function setMapEtc(i_State: StoreState_t) {
  // TODO: update map, graph, etc.
  // console.log("index.ts :: setMapEtc :: state: " + i_State);


  /*
  if (i_State.currentRoute === "nation") drawNation();
  else if (i_State.currentRoute === "state") drawState(i_State);
  else if (i_State.currentRoute === "county") drawCounty(i_State);
  */


  return 0;
}

function setShareURLs(state: StoreState_t) {
  const customArr = state.personnelNation.filter(item => item.jurisdiction == 'Custom');
      let customPopQuery = '';
      if (customArr !== []) {
        for (let i = 0; i < customArr.length; i++) {
          customPopQuery = customPopQuery + customArr[i].population + ',';
        }
      }
      let sliderNum = '';
      switch(state.vaccinationRateSliderNum) {
            case 1: sliderNum = "-30"; break;
            case 2: sliderNum = "-20"; break;
            case 3: sliderNum = "-10"; break;
            case 4: sliderNum = "0"; break;
            case 5: sliderNum = "10"; break;
            case 6: sliderNum = "20"; break;
            case 7: sliderNum = "30"; break;
            default: sliderNum = "0"; break;
          }
      const queryString = '?vacc_display=' + state.displayOutput + '&vacc_goal=' + state.vaccinationGoal + '&vacc_rate=' + sliderNum + '&pers_hrs_shift=' + state.shiftHours + '&pers_per_hr=' + state.vaxPerHour + '&pers_shifts=' + state.shiftsPerDay + '&pers_duration=' + state.campaignDuration + '&pers_pop=' + customPopQuery + '&pers_overview=' + state.personnelOption;

      const emailString = '?vacc_display=' + state.displayOutput + '%26vacc_goal=' + state.vaccinationGoal + '%26vacc_rate=' + sliderNum + '%26pers_hrs_shift=' + state.shiftHours + '%26pers_per_hr=' + state.vaxPerHour + '%26pers_shifts=' + state.shiftsPerDay + '%26pers_duration=' + state.campaignDuration + '%26pers_pop=' + customPopQuery + '%26pers_overview=' + state.personnelOption;

      state.queryURL = state.shareURL + queryString;
      
      state.emailHref = "mailto:?subject=IEM COVID-19 Vaccination Modeling&body=" + state.shareURL + emailString;
}

async function setLoadedData(state: StoreState_t) {
  // initial loading
  state.isDataLoaded = await dl.loadData();

  // set timestamp value
  let timestamp = dl.getTimestamp();
  const timestampArr = timestamp.split('-');
  timestamp = timestampArr[1] + "/" + timestampArr[2].substr(0,2) + "/" + timestampArr[0];
  state.timestamp = timestamp;
  // console.log("setLoadedData :: state.timestamp: " + state.timestamp);

  // FIPS
  const dsFips = dl.getFips();
  state.fipsDataRaw = dsFips;
  // console.log("index.ts :: setLoadedData :: state.fipsDataRaw:");
  // console.log(state.fipsDataRaw);

  let stateCount = 0;
  let countyCount = 0;
  dsFips.forEach( fipsData => {
    if (fipsData.fips < 100) stateCount++;
    else if (fipsData.fips > 100) countyCount++;
  });

  // get no vaccination data set
  const vd = dl.getLastValidDate();
  const ds: Map<string,dl.modelData_t> = await dl.getModelDataPromise("NoVaccinations");

  let fipsNation: UiFipsT = null;
  const fipsStateArray = new Array<UiFipsT>(stateCount);
  const fipsCountyArray = new Array<UiFipsT>(countyCount);

  stateCount = 0;
  countyCount = 0;
  dsFips.forEach( fipsData => {
    const caseCount = ds.get(fipsData.fipsCode + ":" + vd).projectedCasesBest;
    const deathCount = ds.get(fipsData.fipsCode + ":" + vd).projectedDeathsBest;
    // TODO: why does === 0 not work for nation?
    if (fipsData.fips == 0) fipsNation = {fipsCode: fipsData.fipsCode, name: fipsData.name, population: fipsData.population, abbrev: fipsData.abbrev, parent: null, fullName: null, noVaxCaseCount: caseCount, noVaxDeathCount: deathCount};
    else if (fipsData.fips < 100) fipsStateArray[stateCount++] = {fipsCode: fipsData.fipsCode, name: fipsData.name, population: fipsData.population, abbrev: fipsData.abbrev, parent: '00', fullName: fipsData.fullName, noVaxCaseCount: caseCount, noVaxDeathCount: deathCount };
    else if (fipsData.fips > 100) fipsCountyArray[countyCount++] = {fipsCode: fipsData.fipsCode, name: fipsData.name, population: fipsData.population, abbrev: dsFips.get(fipsData.parentFipsCode).abbrev + "-" + fipsData.abbrev, parent: fipsData.parentFipsCode, fullName: fipsData.fullName, noVaxCaseCount: caseCount, noVaxDeathCount: deathCount};
  });
  fipsStateArray.sort((el1,el2) => {
    if (el1.name === null && el2.name === null) return 0;
    if (el1.name === null) return -1;
    if (el2.name === null) return 1;

    if (el1.name < el2.name) return -1;
    if (el1.name > el2.name) return 1;

    return 0;
  });
  fipsCountyArray.sort((el1,el2) => {
    if (el1.name === null && el2.name === null) return 0;
    if (el1.name === null) return -1;
    if (el2.name === null) return 1;

    if (el1.name < el2.name) return -1;
    if (el1.name > el2.name) return 1;

    return 0;
  });

  state.fipsNation = fipsNation;
  state.fipsStateArray = fipsStateArray.filter((o) => o != undefined);
  state.fipsCountyArray = fipsCountyArray;
  state.selectedCounty = fipsCountyArray[0].fipsCode;
  state.selectedCountyName = fipsCountyArray[0].name;
  state.selectedState = fipsStateArray[0].fipsCode;
  state.selectedStateName = fipsStateArray[0].name;

  // console.log("index.ts :: setLoadedData :: fips arrays");
  // console.log(state.fipsNation);
  // console.log(state.fipsCountyArray);

  if (state.currentRoute === 'state') {
    const tempAbbrev = state.selectedStateAbbrev;
      const route = '/state/' + tempAbbrev.toLowerCase();
      state.stateNavRoute = route;
      const newState = state.fipsStateArray.filter(o => o.abbrev === tempAbbrev)[0];
    if (newState !== undefined)
      {
        state.selectedState = newState.fipsCode;
        state.selectedStateName = newState.name;
        drawState(state);
      }
  }
  else if (state.currentRoute === 'county') {
    const tempAbbrev = state.selectedCountyURL.toLowerCase();
    const newCounty = fipsCountyArray.filter(o => o.abbrev === tempAbbrev)[0];

    if (newCounty !== undefined) {
      state.selectedCounty = newCounty.fipsCode;
      state.selectedCountyName = newCounty.name;
      drawCounty(state);
    }
  }
  setPersonnelDisplay(state);

  // console.log("setLoadedData :: HERE");
  // console.log(getMaxModelCounts("42133","200M","baseRate"));
  // console.log(getMaxModelCounts("42133","200M","+10%"));
  setNationTable(state);
  setStateCountyArray(state, 'state');
  setStateCountyArray(state, 'county');
  averted(state, 'state');
  averted(state, 'county');
}

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentRoute: 'nation',
    showObjective: 0,
    emailHref: '',
    shareURL: '',
    queryURL: '',
    selectedState: '01',
    selectedStateAbbrev: 'al',
    selectedStateName: 'Alabama',
    selectedStateCounties: [],
    stateNavRoute: '/state/al',
    selectedCounty: '',
    selectedCountyName: '',
    selectedCountyURL: '',
    vaccinationGoal: "200M",
    targetPercent: .606,
    vaccinationRateSliderNum: 4,
    vaccinationRateSlider: "baseRate",
    vaccinationRateLabel: "Base Rate",
    selectedMap: 'heatmap',
    selectedMapClass: 'heatmapSelected',
    timestamp: '',
    displayOutput: 'cases',
    copyDisplay: 'benefits',
    isDataLoaded: false,
    fipsDataRaw: null,
    fipsNation: null,
    fipsStateArray: null,
    fipsCountyArray: null,
    personnelNation: [],
    personnelCounties: [],
    personnelOption: 'nation',
    shiftHours: 6,
  vaxPerHour: 20,
  shiftsPerDay: 2,
  campaignDuration: 100,
  totalVaxPerDay: 2400,
    nationDataArray: [],
    nationPageNo: 1,
    stateDataArray: [],
    countyDataArray: [],
    nationCasesAverted: 0,
    nationDeathsAverted: 0,
    stateCasesAverted: 0,
    stateDeathsAverted: 0,
    countyCasesAverted: 0,
    countyDeathsAverted: 0
  },
  mutations: {
    init(state,value) {
      if (value === undefined) {
        setLoadedData(state);
      }
      else {
      // general query parameters
      if (value.vacc_display === 'cases' || value.vacc_display == 'deaths') {
        state.displayOutput = value.vacc_display;
      }
      if (value.vacc_goal === '100M' || value.vacc_goal === '200M') {
        state.vaccinationGoal = value.vacc_goal;
        if (value.vacc_goal === '100M') {
        state.targetPercent = .303
      }
      else {
        state.targetPercent = .606
      }
      }
      
      // Personnel query parameters
      if ( isNaN(parseInt(value.pers_hrs_shift)) === false) {
        state.shiftHours = value.pers_hrs_shift;
      }
      if ( isNaN(parseInt(value.pers_per_hr)) === false) {
        state.vaxPerHour = value.pers_per_hr;
      }
      if ( isNaN(parseInt(value.pers_shifts)) === false) {
        state.shiftsPerDay = value.pers_shifts;
      }
      if (value.pers_overview === 'nation' || value.pers_overview === 'county') {
        state.personnelOption = value.pers_overview;
      }
      if ( isNaN(parseInt(value.pers_duration)) === false) {
        state.campaignDuration = value.pers_duration;
      }
      if (value.vacc_rate !== undefined) {
        let label;
        let tick;
        switch(value.vacc_rate) {
            case '-30': label = "-30%"; tick = 1; break;
            case '-20': label = "-20%"; tick = 2; break;
            case '-10': label = "-10%"; tick = 3; break;
            case '0': label = "baseRate"; tick = 4; break;
            case '10': label = "+10%"; tick = 5; break;
            case '20': label = "+20%"; tick = 6; break;
            case '30': label = "+30%"; tick = 7; break;
            default: label = "baseRate"; tick = 4; break;
          }
        state.vaccinationRateSliderNum = tick;
        state.vaccinationRateSlider = label;
        if (label === 'baseRate') {
          state.vaccinationRateLabel = 'Base Rate';
        }
        else {
          state.vaccinationRateLabel = label;
        }
      }
      setLoadedData(state).then(() => {
        if (value.pers_pop !== undefined) {
          const arr = value.pers_pop.split(',');
          const newNationArr = [
        ...state.personnelNation];
      // state.personnelNation = newNationArr;
      const newCountyArr = [...state.personnelCounties];
      // state.personnelCounties = newCountyArr;
          for (let i = arr.length; i >= 0; i--) {
            if (isNaN(parseInt(arr[i])) === false) {
              let clinics = (arr[i] * state.targetPercent) / 24000;
  clinics = Math.ceil(clinics);
  const workers = clinics * 170 * 2;
  const obj = {
    jurisdiction: "Custom",
    population: arr[i],
    clinics: clinics,
    workers: workers
  };
  newNationArr.unshift(obj);
  newCountyArr.unshift(obj);
            }
          }
          state.personnelNation = newNationArr;
          state.personnelCounties = newCountyArr;
        }
        
      //   if ( isNaN(parseInt(value.pers_pop)) === false) {
      //   state.shiftsPerDay = value.pers_pop;
      // };
      }); // asynchronous
    }
    },
    showObjective(state, value) {
      state.showObjective = value;
    },
    drawCounty (state) {
      drawCounty(state);
    },
    drawState (state) {
      drawState(state);
    },
    selectState(state, value) {
      
      state.selectedState = value;
      if (value !== '00') {
        const tempArr = state.fipsStateArray;
        const tempState = tempArr.filter((o: States) => o.fipsCode === value)[0];
        state.selectedStateAbbrev = tempState.abbrev;
        state.selectedStateName = tempState.name;
        setStateCountyArray(state, 'state');
        // createExcel(state,'state');
        averted(state,'state');
      }
      else {
        state.selectedStateAbbrev = 'USA';
        state.selectedStateName = 'USA';
        state.selectedStateCounties = state.fipsCountyArray;
        state.selectedCounty = state.selectedStateCounties[0].fipsCode;
        state.selectedCountyName = state.selectedStateCounties[0].name;
      }
      // setPersonnelDisplay(state);

      drawState(state);
    },
    searchByAbbrev(state, value) {
      state.selectedStateAbbrev = value;
      if (state.isDataLoaded) {
      const tempArr = state.fipsStateArray;
      const route = '/state/' + value.toLowerCase();
      state.stateNavRoute = route;
      const tempState = tempArr.filter((o: States) => o.abbrev === value)[0];
      state.selectedState = tempState.fipsCode;
      drawState(state);
      state.selectedStateName = tempState.name;
      setStateCountyArray(state, 'state');
      averted(state, 'state');
      
      }
    },
    selectStateAbbrev(state, value) {
      state.selectedStateAbbrev = value;
      const route = '/state/' + value.toLowerCase();
      state.stateNavRoute = route;
    },
    selectCounty(state, value) {
      state.selectedCounty = value;
      const tempCounty = state.fipsCountyArray.filter((county: UiFipsT) => county.fipsCode === value);
      state.selectedCountyName = tempCounty[0].name;
  setStateCountyArray(state, 'county');
      // createExcel(state,'county');
      averted(state,'county');
      setMapEtc(state);
    },
    searchByCountyURL(state, value) {
      state.selectedCountyURL = value;
      if (state.isDataLoaded) {
        const tempCounty = state.fipsCountyArray.filter((county: UiFipsT) => county.abbrev === value);
      state.selectedCounty = tempCounty[0].fipsCode;
      state.selectedCountyName = tempCounty[0].name;
  setStateCountyArray(state, 'county');
      averted(state,'county');
      }
    },
    selectVaxGoal(state, value) {
      state.vaccinationGoal = value;
      if (value === '100M') {
        state.targetPercent = .303
      }
      else {
        state.targetPercent = .606
      }
      updatePersonnelDisplay(state);
      setNationTable(state);
      setStateCountyArray(state, 'state');
  setStateCountyArray(state, 'county');
      averted(state,'state');
      averted(state,'county');
       setShareURLs(state);
    },
    setShiftHours(state, value) {
      state.shiftHours = value;
      updatePersonnelDisplay(state);
       setShareURLs(state);
    },
    setShiftsPerDay(state, value) {
      state.shiftsPerDay = value;
      updatePersonnelDisplay(state);
       setShareURLs(state);
    },
    setVaxPerHour(state, value) {
      state.vaxPerHour = value;
      updatePersonnelDisplay(state);
       setShareURLs(state);
    },
    setCampaignDuration(state, value) {
      state.campaignDuration = value;
      updatePersonnelDisplay(state);
       setShareURLs(state);
    },
    selectVaxRate(state, value) {
      state.vaccinationRateSlider = value;
      if (value==="baseRate") {
        state.vaccinationRateLabel = "Base Rate";
      }
      else {
        state.vaccinationRateLabel = value;
      }
      setNationTable(state);
      setStateCountyArray(state, 'state');
  setStateCountyArray(state, 'county');
      averted(state,"state");
      averted(state,"county");
       setShareURLs(state);
    },
    selectVaxRateNum(state, value) {
      state.vaccinationRateSliderNum = value;
    },
    selectPersonnelOption(state, value) {
      state.personnelOption = value;
       setShareURLs(state);
    },
    selectMap(state, value) {
      state.selectedMap = value;
      if (value==='heatmap') {
        state.selectedMapClass = 'heatmapSelected';
      }
      else {
        state.selectedMapClass = 'bivariateSelected';
      }
    },
    selectOutput(state, value) {
      state.displayOutput = value;
       setShareURLs(state);
    },
    setRoute(state, value) {
      state.currentRoute = value;
      setMapEtc(state);
    },
    setHref(state,value) {
      const shareURL = 'https://vaccinations.iem-modeling.com' + value;
      state.shareURL = shareURL;
      setShareURLs(state);
    },
    setCopyDisplay(state, value) {
      state.copyDisplay = value;
    },
    addCustomPersonnel(state, value) {
      const newNationArr = [value,
        ...state.personnelNation];
      state.personnelNation = newNationArr;
      const newCountyArr = [value,
        ...state.personnelCounties];
      state.personnelCounties = newCountyArr;
      
    },
    setPageNo(state, value) {
      state.nationPageNo = value;
    },
    resetPersonnelValues(state) {
      state.shiftHours = 6;
      state.vaxPerHour = 20;
      state.shiftsPerDay = 2;
      state.campaignDuration = 100;
      updatePersonnelDisplay(state);
    },
    resetPersonnelCustom(state) {
      resetPersonnelCustom(state);
    }
  },
  actions: {
    init (context, value) {
      context.commit('init', value);
    },
    selectState (context, value) {
      context.commit('selectState', value)
    },
    selectStateAbbrev (context, value) {
      context.commit('selectStateAbbrev', value)
    },
    searchByAbbrev (context, value) {
      context.commit('searchByAbbrev', value)
    },
    selectCounty (context, value) {
      context.commit('selectCounty', value)
    },
    searchByCountyURL (context, value) {
      context.commit('searchByCountyURL', value)
    },
    selectVaxGoal (context, value) {
      context.commit('selectVaxGoal', value)
    },
    selectVaxRate (context, value) {
      context.commit('selectVaxRate', value)
    },
    selectVaxRateNum (context, value) {
      context.commit('selectVaxRateNum', value)
    },
    selectMap (context, value) {
      context.commit('selectMap', value)
    },
    selectOutput (context, value) {
      context.commit('selectOutput', value)
    },
    drawCounty (context) {
      context.commit('drawCounty')
    },
    drawNation (context) {
      drawNation();
    },
    drawPersonnel (context) {
      drawPersonnel();
    },
    drawState (context) {
      context.commit('drawState')
    },
    setRoute (context, value) {
      context.commit('setRoute', value)
    },
    setHref (context, value) {
      context.commit('setHref', value);
    },
    setCopyDisplay (context, value) {
      context.commit('setCopyDisplay', value)
    },
    addCustomPersonnel (context, value) {
      context.commit('addCustomPersonnel', value)
    },
    selectPersonnelOption (context, value) {
      context.commit('selectPersonnelOption', value)
    },
    setPageNo (context, value) {
      context.commit('setPageNo', value);
    },
    setShiftHours (context, value) {
      context.commit('setShiftHours', value);
    },
    setShiftsPerDay (context, value) {
      context.commit('setShiftsPerDay', value);
    },
    setCampaignDuration (context, value) {
      context.commit('setCampaignDuration', value);
    },
    setVaxPerHour (context, value) {
      context.commit('setVaxPerHour', value);
    },
    resetPersonnelValues (context) {
      context.commit('resetPersonnelValues');
    },
    showObjective(context,value) {
      context.commit('showObjective',value);
    },
    resetPersonnelCustom(context) {
      context.commit('resetPersonnelCustom');
    }
  },
  modules: {
  }
})